import React, { useState } from "react";
import { Wrapper, TextArea, ButtonContainer, Footer } from "./style";
import { MODAL_EDIT_MEND } from "store/Modals/constants";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/Modals/actions";
import LabelOnlyButton from "components/commons/Buttons/LabelOnlyButton";
import colors from "styles/colors";
import { requestMendingPaperwork } from "store/PaperWork/actions/requests";
import { selectPaperworkMetadata } from "store/PaperWork/selectors";
import { PLACEHOLDER, SEND } from "./constants";
import { isNull, isEmpty } from "utils/functions";
import SubsanationOptions from "../SubsanationOptions";
import get from "lodash/get";

const Content = ({ expanded }) => {
  const dispatch = useDispatch();
  const metadata = useSelector(selectPaperworkMetadata);
  const id = get(metadata, "id", null);
  const [text, setText] = useState(null);
  const [area, setArea] = useState(null);
  const data = { reason: text, mendingArea: area };

  const handleObservation = (e) => {
    setText(e.target.value);
  };

  const requestMend = () => {
    dispatch(closeModal(MODAL_EDIT_MEND));
    dispatch(requestMendingPaperwork(id, data));
  };

  return (
    <Wrapper expanded={expanded}>
      <SubsanationOptions setArea={setArea} />
      <TextArea onChange={(e) => handleObservation(e)} placeholder={PLACEHOLDER} />
      <Footer>
        <ButtonContainer>
          <LabelOnlyButton
            background={colors.blue40}
            color={colors.white}
            label={SEND}
            onClick={requestMend}
            disabled={isNull(text) || isEmpty(text)}
          />
        </ButtonContainer>
      </Footer>
    </Wrapper>
  );
};

export default Content;
